import React, {useEffect, useMemo, useState} from 'react';
import {useAuth, useDarkMode} from "../../../context";
import {Link, useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useGetJson, useInfiniteScroll, usePostJson} from "../../../hooks";
import {endpoints} from "../../../utils2";
import * as yup from "yup";
import {Alert, Button, ListGroup, Stack} from "react-bootstrap";
import {AdminUserAlert, ColumnizeText, DynamicDialog, OurAlert, PageTitle, SelectText, SingleText} from "../../_components";
import {Formik, Form as FormikForm, useFormikContext} from "formik";
import {WhiteCard} from "../_components/WhiteCard";
import {DeviceProject} from "../../../utils2/maps";
import hysteresisLight from "../icons/case_hysteresis_light.svg";
import hysteresisDark from "../icons/case_hysteresis_dark.svg"

export function AddEditControlledBy() {
    const {userId, authToken} = useAuth()
    const {uid, did, cid} = useParams()
    const navigate = useNavigate()
    const location = useLocation()


    useEffect(() => {
        if (cid === "new" && location.state == null) {
            navigate(`/device/${uid}`)
        }
    }, [location, cid])

    const edit = cid !== "new"

    const [ev, loadingEvent, errorEvent, clearErrorEvent] = useGetJson(cid === "new" ? null : endpoints.event.get(cid), authToken?.jwt)
    const event = ev?.data
    const config1 = event?.config1

    const [submitForm, _, loadingAdd, errorAdd, clearErrorAdd] = usePostJson(endpoints.event.edit(cid), authToken?.jwt)

    const validationSchema = yup.object().shape({
        name: yup.string().required("Name is required"),
        controlled_by_id: yup.string().required("Device is required").notOneOf([""], "Device is required"),
        // sensor_start: yup.string().required("Sensor is required"),
        // sensor_stop: yup.string().required("Sensor is required"),
    })

    console.log(location.state)

    const initialValues = {
        name: location.state?.name ||  event?.name || "",
        controlled_by_id: location.state?.ctrl?.controlled_by_id || config1?.controlled_by_id || "",
        button: location.state?.ctrl?.button || config1?.button || 0,
        sensor_start: location.state?.ctrl?.sensor_start || config1?.sensor_start || "",
        sensor_stop: location.state?.ctrl?.sensor_stop || config1?.sensor_stop || "",
        broadcaster: location.state?.ctrl?.broadcaster || config1?.broadcaster || 0,
    }

    function handleOnSubmit(values, action) {
        const payload = {name: values.name, ctrl: values}
        if (edit) {
            submitForm(payload, json => {
                action.setSubmitting(false)
                navigate(`/device/${uid}/${did}/config`)
            })
        } else {
            navigate(location.state.steps[1], {state: {...location.state, ...payload}})
        }
    }

    if (edit && loadingEvent) {
        return <div>Loading...</div>;
    }

    const backTo = -1

    return <Stack>
        <AdminUserAlert/>
        {/*<OurAlert variant="info" show={userId !== uid} msg={`Watch out, you are managing user ID ${uid}.`}/>*/}
        <Alert variant="danger" show={errorEvent} dismissible onClose={clearErrorEvent}>{errorEvent}</Alert>
        <Alert variant="danger" show={errorAdd} dismissible onClose={clearErrorAdd}>{errorAdd}</Alert>

        <PageTitle title="Set Controller Device">{edit ? `Edit ${event?.name}` : `Add configuration`}.</PageTitle>

        <Formik validationSchema={validationSchema} onSubmit={handleOnSubmit} initialValues={initialValues} enableReinitialize={true}>
            {({isSubmitting, resetForm, values}) => (
                <FormikForm>

                    <WhiteCard>
                        <SingleText name="name" label="Name" placeholder="Event name" maxLength={32}/>
                    </WhiteCard>

                    <SelectDevice/>

                    {values.controlled_by_id && <ProjectOptions/>}

                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        <Button as={Link} variant="link" to={backTo}>Go back</Button>
                        <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>{edit ? "Edit" : "Next"}</Button>
                    </Stack>

                </FormikForm>
            )}
        </Formik>

    </Stack>

}

function SelectDevice() {
    const {values, setFieldValue, errors, touched} = useFormikContext()
    const {uid, did, cid} = useParams()
    const {userId, authToken} = useAuth()
    const [show, setShow] = useState(false)
    const [filterText, setFilterText] = useState("")

    const [searchParams, setSearchParams] = useSearchParams()

    const pageSize = Number(searchParams.get("size")) || 10
    const pageIndex = Number(searchParams.get("index")) || 0
    const query = searchParams.get("query")
    const orderBy = searchParams.get("by")

    const filter = {
        device_classes: ["input", "hybrid"],
        offset: pageIndex * pageSize,
        limit: pageSize,
        query: query,
        order_by: orderBy
    }

    const [devList, loadingList, errorDeviceList, clearErrorDeviceList] = useGetJson(endpoints.device.listFilter(uid), authToken?.jwt, null, filter, "POST", [pageSize, pageIndex, query, orderBy])
    const list = devList?.data || []

    const [devCount, loadingDeviceCount, errorDeviceCount, clearErrorDeviceCount] = useGetJson(endpoints.device.countFilter(uid), authToken?.jwt, null, filter, "POST", [pageSize, pageIndex, query, orderBy])
    const count = devCount?.data

    const loading = loadingList || loadingDeviceCount

    const lastElementRef = useInfiniteScroll(loading, list?.length, count, pageSize, () => {
    })

    const tempList = useMemo(() => list?.filter(item => item.id !== values.controlled_by_id), [list, values.controlled_by_id])
    const renderList = useMemo(() => tempList?.filter(item => item.name?.toLowerCase().includes(filterText.toLowerCase())), [filterText, tempList])

    const selectedDevice = list?.find(device => device.id === values.controlled_by_id)?.name

    if (loading) {
        return <div>Loading...</div>;
    }

    function handleSelectDevice(deviceId) {
        setFieldValue("controlled_by_id", deviceId);
        setShow(false)
    }

    return (
        <>
            <Alert variant="danger" show={errorDeviceCount} dismissible onClose={clearErrorDeviceCount}>{errorDeviceCount}</Alert>
            <Alert variant="danger" show={errorDeviceList} dismissible onClose={clearErrorDeviceList}>{errorDeviceList}</Alert>

            <WhiteCard>
                <div className="fw-semibold">Select Device</div>
                {values.controlled_by_id !== "" && <div className="d-flex align-items-center mb-2">
                    <div>{selectedDevice}</div>
                    <Button variant="danger" className="ms-auto" onClick={() => setFieldValue("controlled_by_id", "")}><i className="bi bi-trash"/></Button>
                </div>
                }
                <Button variant="success" size="sm" onClick={() => setShow(true)}><i className="bi bi-plus me-2"/>Device</Button>

                {errors.controlled_by_id && touched.controlled_by_id && (
                    <div className="text-danger">{errors.controlled_by_id}</div>
                )}
            </WhiteCard>

            <DynamicDialog title="Select Device" show={show} onHide={() => setShow(false)} filter={filterText} setFilter={setFilterText}>
                <div>Loaded {list.length - [values.controlled_by_id].length} of {count - [values.controlled_by_id].length}</div>
                {renderList && renderList?.length > 0 ?
                    renderList.map((item, index) => (
                        <ListGroup.Item key={item.id} eventKey={item.id} ref={renderList.length === index + 1 ? lastElementRef : null}>
                            <Button variant="light" onClick={() => handleSelectDevice(item.id)}
                                    className="mb-2 text-start">{item.name} [{item.device_project}]</Button>
                        </ListGroup.Item>
                    ))
                    :
                    <span className="text-center">No device found</span>
                }
            </DynamicDialog>
        </>
    )
}

function ProjectOptions() {
    const {uid} = useParams()
    const {authToken} = useAuth()
    const {values} = useFormikContext()
    const {darkMode} = useDarkMode()

    const [dev, loadingDevice, errorDevice, clearErrorDevice] = useGetJson(endpoints.device.get(uid, values?.controlled_by_id), authToken?.jwt)
    const device = dev?.data

    const buttonOption = [
        {id: 0, name: "Button 1"},
        {id: 1, name: "Button 2"},
    ]

    const broadcasterOption = [
        {id: 0, name: "Playback started"},
        {id: 1, name: "Failed to start playback"},
    ]

    return <>
        {/*<div>{device?.name}</div>*/}
        {device?.device_project === DeviceProject.ButtonNano && <WhiteCard>
            <SelectText name="button" label="Select button">
                <option value="">None</option>
                {buttonOption.map(item => (
                    <option key={item.id} value={item.id}>{item.name}</option>
                ))}
            </SelectText>
        </WhiteCard>}

        {(device?.device_project === DeviceProject.SensorTemperature || device?.device_project === DeviceProject.SensorHumidity) && <WhiteCard>
            <ColumnizeText>
                <SingleText name="sensor_start" label="Threshold start" maxLength={16}/>
                <SingleText name="sensor_stop" label="Threshold stop" maxLength={16}/>
            </ColumnizeText>
            {darkMode ? <img src={hysteresisLight} alt="Hysteresis"/> : <img src={hysteresisDark} alt="Hysteresis"/>}
        </WhiteCard>}

        {(device?.device_project === DeviceProject.NanoEth ||
            device?.device_project === DeviceProject.MicroEth ||
            device?.device_project === DeviceProject.StandardEth) && <WhiteCard>
            <SelectText name="broadcaster" label="Select event">
                {/*<option value="">None</option>*/}
                {broadcasterOption.map(item => (
                    <option key={item.id} value={item.id}>{item.name}</option>
                ))}
            </SelectText>
        </WhiteCard>}
    </>
}